import { render, staticRenderFns } from "./CreateTicimaxChannel.vue?vue&type=template&id=589176b6&scoped=true"
import script from "./CreateTicimaxChannel.vue?vue&type=script&lang=js"
export * from "./CreateTicimaxChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateTicimaxChannel.vue?vue&type=style&index=0&id=589176b6&prod&lang=scss&scoped=true"
import style1 from "./CreateTicimaxChannel.vue?vue&type=style&index=1&id=589176b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589176b6",
  null
  
)

export default component.exports